import {
  FETCH_JIRA_ISSUE_DETAILS_REQUEST,
  FETCH_JIRA_ISSUE_DETAILS_SUCCESS,
  FETCH_JIRA_ISSUE_DETAILS_FAILURE
} from "./types";

const initialState = {
  isLoading: false,
  error: "",
  jiraIssueDetails: []
};
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_JIRA_ISSUE_DETAILS_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case FETCH_JIRA_ISSUE_DETAILS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        jiraIssueDetails: action.payload.data,
        error: ""
      };
    case FETCH_JIRA_ISSUE_DETAILS_FAILURE:
      return {
        ...state,
        isLoading: false,
        jiraIssueDetails: [],
        error: action.payload
      };

    default:
      return state;
  }
};

export default reducer;
